import { render, staticRenderFns } from "./AllowancesPlans.vue?vue&type=template&id=3f96cbe1&"
import script from "./AllowancesPlans.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports